<button app-mat-button class="linkToDD" *ngIf="project?.linkedProjectId" (click)="openWithDroneDeploy()">
  View in DroneDeploy
  <span class="icon-button ri-external-link"></span>
</button>
